<div class="nav-icon-container">
  <div class="navicon" [ngClass]="classes" (click)="toggle()" [matTooltip]="tooltip">
    <!--     <span *ngFor="let i of [1,2,3]" class="navicon-bar" [style.background-color]="color"></span> -->
    <svg focusable="false" viewBox="0 0 24 24">
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
    </svg>

  </div>
  <!-- <i class="close-icon fas fa-angle-left" [ngClass]="classes" [style.color]="color"></i> -->
</div>